import { Controller } from "@hotwired/stimulus"

// Staff PIN keypad for exiting kiosk mode. Staff PINs are exactly 4 digits
// (AccountUser::PIN_LENGTH), so we auto-submit once the fourth digit lands.
const PIN_LENGTH = 4

export default class extends Controller {
  static targets = ["input", "dotsContainer", "keypad", "form"]

  connect() {
    this.pin = ""
    this.submitting = false
    this.updateDisplay()
  }

  press(event) {
    if (this.submitting) return
    const key = event.currentTarget.dataset.key
    if (key === "⌫") {
      this.pin = this.pin.slice(0, -1)
    } else if (this.pin.length < PIN_LENGTH) {
      this.pin += String(key)
    }
    this.updateDisplay()
    if (this.pin.length === PIN_LENGTH) this.submit()
  }

  clear() {
    if (this.submitting) return
    this.pin = ""
    this.updateDisplay()
  }

  submit() {
    if (this.submitting || this.pin.length < PIN_LENGTH) return
    this.submitting = true
    this.setKeypadDisabled(true)
    if (this.hasInputTarget) this.inputTarget.value = this.pin
    if (this.hasFormTarget) this.formTarget.requestSubmit()
  }

  updateDisplay() {
    if (!this.hasDotsContainerTarget) return
    this.dotsContainerTarget.innerHTML = ""
    for (let i = 0; i < PIN_LENGTH; i++) {
      this.dotsContainerTarget.appendChild(this.buildDot(i < this.pin.length))
    }
  }

  buildDot(filled) {
    const el = document.createElement("span")
    el.className = "inline-flex w-12 h-12 rounded-full border-2 transition-all duration-300 shrink-0 " +
      (filled
        ? "bg-indigo-400 border-indigo-400 shadow-[0_0_16px_-4px_rgba(99,102,241,0.5)]"
        : "bg-transparent border-white/30")
    el.setAttribute("aria-hidden", "true")
    return el
  }

  setKeypadDisabled(disabled) {
    if (this.hasKeypadTarget) {
      this.keypadTarget.querySelectorAll("button").forEach((btn) => { btn.disabled = disabled })
    }
  }
}
